export enum HowToFields {
  howToId = "howToId",

  name = "name",
  description = "description",
  pages = "pages",

  createdAt = "createdAt",
  updatedAt = "updatedAt",
}
